const inboxLang = {
  List: {
    Title: 'Inbox',
    ChannelType: {
      Options: {
        SUPPORT: 'Support',
        CLIENT: 'Client',
      },
    },
    Caregiver: {
      Label: 'Caregiver',
    },
    Client: {
      Label: 'Client',
    },
    You: 'You',
    Attachment: 'Attachment',
    ChannelCount: '#{count} total',
    UnreadCount: '#{count} Unread',
    LoadMore: 'Load more',
    Refresh: 'Refresh channels',
    Loading: 'Loading channels...',
    LoadFailed: 'Could not load channels.',
    Empty: 'No channels match this filter.',
    NoChannelSelected: 'No channel selected',
  },
  NewChannel: {
    Title: 'New caregiver chat',
    Description: 'Pick a caregiver to open their support chat. If one already exists, it opens instead of creating a new one.',
    Caregiver: {
      Label: 'Caregiver',
    },
    Confirm: 'Open chat',
    CreateFailed: 'Could not open a chat for this caregiver.',
  },
  Thread: {
    Loading: 'Loading messages...',
    LoadFailed: 'Could not load messages.',
    Empty: 'No messages yet.',
    Placeholder: 'Write a message...',
    Send: 'Send',
    SendFailed: 'Could not send this message.',
    Refresh: 'Refresh messages',
    Disconnected: 'Connection lost. New messages will not arrive until you reconnect.',
    Reconnect: 'Reconnect',
  },
  Detail: {
    NoChannelSelected: 'No channel selected',
    NoParticipants: 'No participants yet.',
    Collapse: 'Collapse details',
    Expand: 'Expand details',
    Fields: {
      Participants: 'Participants',
    },
    Client: {
      Loading: 'Loading client...',
      LoadFailed: 'Could not load this client.',
      Fields: {
        CareRecipient: 'Care recipient',
        Location: 'Location',
        Contacts: 'Contacts',
      },
    },
    ResourceKinds: {
      CLIENT: 'Client',
      CAREGIVER: 'Caregiver',
      CASE: 'Case',
      RELATIONSHIP: 'Client contact',
    },
  },
};

export default inboxLang;
